module.exports = __webpack_public_path__ + "static/img/6.b96ef0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/6.png
// module id = PwXT
// module chunks = 0